import React, { useEffect, useState } from "react";
import { DatePicker, Input, Switch } from "antd";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import {
  currentUnits,
  pressureUnits,
  temperatureUnits,
} from "../../../../Data/data";
import UnitWithInput from "../../../../components/UnitWithInput";
import moment from "moment";
import dayjs from "dayjs";

function AuxiliaryPurifier({ eng_log_basic_id, _items }) {
  const [errors, set_errors] = useState({});
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [feed_Pr, set_Feed_Pr] = useState("");
  const [back_Pr, set_Back_Pr] = useState("");
  const [feed_Temp, set_Feed_Temp] = useState("");
  const [motor_Current, set_Motor_Current] = useState("");
  const [motor_Temp, set_Motor_Temp] = useState("");
  const [vibration, set_Vibration] = useState("");
  const [checked, setChecked] = useState(false);
  const [running_Hour, set_Running_Hour] = useState("");
  const [total_Running_Hour, set_Total_Running_Hour] = useState("");
  const [update_status, set_update_status] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(false);
  const [logDate, set_LogDate] = useState(null);
  const [purifier_Feed_Pressure_Unit, set_Purifier_Feed_Pressure_Unit] =
    useState("");
  const [purifier_Back_Pressure_Unit, set_Purifier_Back_Pressure_Unit] =
    useState("");
  const [purifier_Feed_Temp_Unit, set_Purifier_Feed_Temp_Unit] = useState("");
  const [purifier_Motor_Current_Unit, set_Purifier_Motor_Current_Unit] =
    useState("");
  const [purifier_Motor_Temp_Unit, set_Purifier_Motor_Temp_Unit] = useState("");
  const [vibration_Unit, set_Vibration_Unit] = useState("");
  const [otherParams, setOtherParams] = useState({});

  // Map parameter names to labels and units
  const parameterConfig = {
    runningHours: { label: "Running Hour", unitList: [] },
    totalRunningHours: { label: "Total Running Hour", unitList: [] },
    feedPressure: { label: "Feed Pressure", unitList: pressureUnits },
    backPressure: { label: "Back Pressure", unitList: pressureUnits },
    feedTemperature: { label: "Feed Temp", unitList: temperatureUnits },
    motorCurrent: { label: "Motor Current", unitList: currentUnits },
    motorTemperature: { label: "Motor Temp", unitList: temperatureUnits },
  };

  useEffect(() => {
    if (_items?.id) VIEW_AUXILIARY_PURIFIER_DETAILS_LOGBOOK_API(_items?.id);
    const otherParamsData = Array.isArray(_items?.other_parameters)
      ? _items.other_parameters
      : [];
    const initialOtherParams = otherParamsData.reduce((acc, param) => {
      const paramName = param.name || "";
      acc[paramName] = {
        name: paramName,
        value: param.value || "",
        unit: param.unit || "",
      };
      return acc;
    }, {});
    setOtherParams(initialOtherParams);
  }, [_items?.id]);

  const onChangeDateTime = (value) => {
    if (value) {
      set_LogDate(value.format("YYYY-MM-DD HH:mm:ss"));
    } else {
      set_LogDate(null);
    }
  };

  const handleOtherParamChange = (name, field, value) => {
    setOtherParams((prev) => ({
      ...prev,
      [name]: { ...prev[name], [field]: value },
    }));
  };

  const VIEW_AUXILIARY_PURIFIER_DETAILS_LOGBOOK_API = async (purifier_Id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("purifier_id", purifier_Id);
      FORM_DATA.append("eng_log_basic_id", eng_log_basic_id);
      post(ApiURL.view_auxiliary_purifier_info_com, FORM_DATA).then((res) => {
        const purifier_Data = res?.response_data;
        if (res?.status === true) {
          set_update_status(purifier_Data?.complete_status);
          set_Feed_Pr(purifier_Data?.pr_feed_pressure || "");
          set_Back_Pr(purifier_Data?.pr_back_pressure || "");
          set_Feed_Temp(purifier_Data?.pr_feed_temp || "");
          set_Motor_Current(purifier_Data?.pr_motor_current || "");
          set_Motor_Temp(purifier_Data?.pr_motor_temp || "");
          set_Vibration(purifier_Data?.pr_vibration || "");
          setChecked(purifier_Data?.purifier_on_off || false);
          set_Running_Hour(purifier_Data?.purifier_running_hours || "");
          set_Total_Running_Hour(
            purifier_Data?.purifier_total_running_hours || ""
          );
          // setSubmitStatus(purifier_Data?.submit_status || false);
          setSubmitStatus(true);

          set_LogDate(
            purifier_Data?.date_time_log ||
              moment().format("YYYY-MM-DD HH:mm:ss")
          );
          set_Purifier_Feed_Pressure_Unit(
            purifier_Data?.pr_feed_pressure_unit || ""
          );
          set_Purifier_Back_Pressure_Unit(
            purifier_Data?.pr_back_pressure_unit || ""
          );
          set_Purifier_Feed_Temp_Unit(purifier_Data?.pr_feed_temp_unit || "");
          set_Purifier_Motor_Current_Unit(
            purifier_Data?.pr_motor_current_unit || ""
          );
          set_Purifier_Motor_Temp_Unit(purifier_Data?.pr_motor_temp_unit || "");
          set_Vibration_Unit(purifier_Data?.pr_vibration_unit || "");

          // const itemParams = _items?.other_parameters || [];
          const rawItemParams = _items?.other_parameters;
          const itemParams = Array.isArray(rawItemParams) ? rawItemParams : [];
          const purifierParams = purifier_Data?.other_parameters || {};

          // Merge the two datasets
          const mergedParams = itemParams?.map((param) => {
            const paramName = param.name;
            const purifierEntry = purifierParams[paramName] || {};
            return {
              name: paramName,
              unit: param.unit || purifierEntry.unit || "",
              value: purifierEntry.value || param.value || "",
            };
          });

          const otherParamsData = Array.isArray(mergedParams)
            ? mergedParams
            : [];
          const initialOtherParams = otherParamsData.reduce((acc, param) => {
            acc[param.name] = {
              name: param.name,
              value: param.value || "",
              unit: param.unit || "",
            };
            return acc;
          }, {});
          setOtherParams(initialOtherParams);
        } else {
          set_errors(res?.errors || {});
        }
      });
    } catch (error) {
      console.error("Error updating logbook:", error);
    }
  };

  const otherParameterUnits = [
    ...new Set(Object.values(otherParams || {}).map((param) => param.unit)),
  ];

  return (
    <>
      <div className="row custom-box">
        <div className="col-3">
          <b style={{ color: "#161515", fontSize: "15px" }}>
            Purifier Make:- {_items?.purifier_make}
          </b>
        </div>
        <div className="col-3">
          <b style={{ color: "#161515", fontSize: "15px" }}>
            Purifier Model:- {_items?.purifie_model}
          </b>
        </div>
        <div className="col-3">
          <b style={{ color: "#161515", fontSize: "15px" }}>
            Purifier title:- {_items?.title}
          </b>
        </div>
        <div className="col-3">
          <b style={{ color: "#161515", fontSize: "15px" }}>
            Purifier Id:- {_items?.id}
          </b>
        </div>
        <div className="col-2">
          <Switch
            disabled={submitStatus}
            checked={checked}
            // onChange={(value) => {
            //   setChecked(value);
            //   if (value || !value) {
            //     update_status
            //       ? UPDATE_AUXILIARY_PURIFIER_DETAILS_LOGBOOK_API(_items?.id, "0", value)
            //       : ADD_AUXILIARY_PURIFIER_DETAILS_LOGBOOK_API(_items?.id, value);
            //   }
            // }}
            checkedChildren="On"
            unCheckedChildren="Off"
            style={{ backgroundColor: checked ? "green" : "red" }}
          />
        </div>
      </div>

      {checked && (
        <>
          {(() => {
            const rows = [];

            // Prepare the list of inputs: Start with Date & Time
            const inputs = [
              {
                type: "dateTime",
                name: "dateTime",
                value: logDate,
              },
            ];

            // Add all selected parameters
            const selectedParams = _items.selected_parameters || [];
            selectedParams.forEach((param) => {
              const config = parameterConfig[param];
              if (config) {
                const stateMap = {
                  runningHours: [running_Hour, set_Running_Hour],
                  totalRunningHours: [
                    total_Running_Hour,
                    set_Total_Running_Hour,
                  ],
                  feedPressure: [feed_Pr, set_Feed_Pr],
                  backPressure: [back_Pr, set_Back_Pr],
                  feedTemperature: [feed_Temp, set_Feed_Temp],
                  motorCurrent: [motor_Current, set_Motor_Current],
                  motorTemperature: [motor_Temp, set_Motor_Temp],
                  vibration: [vibration, set_Vibration],
                };
                const [value] = stateMap[param] || [];
                const unitStateMap = {
                  feedPressure: [
                    purifier_Feed_Pressure_Unit,
                    set_Purifier_Feed_Pressure_Unit,
                  ],
                  backPressure: [
                    purifier_Back_Pressure_Unit,
                    set_Purifier_Back_Pressure_Unit,
                  ],
                  feedTemperature: [
                    purifier_Feed_Temp_Unit,
                    set_Purifier_Feed_Temp_Unit,
                  ],
                  motorCurrent: [
                    purifier_Motor_Current_Unit,
                    set_Purifier_Motor_Current_Unit,
                  ],
                  motorTemperature: [
                    purifier_Motor_Temp_Unit,
                    set_Purifier_Motor_Temp_Unit,
                  ],
                  vibration: [vibration_Unit, set_Vibration_Unit],
                };
                const [unit] = unitStateMap[param] || [];
                inputs.push({
                  type: "selectedParam",
                  name: param,
                  config,
                  value,
                  unit,
                });
              }
            });

            // Render inputs in groups of 3
            for (let i = 0; i < inputs.length; i += 3) {
              const group = inputs.slice(i, i + 3);
              rows.push(
                <div className="row" key={`combined-row-${i}`}>
                  {group.map((input, idx) => (
                    <div
                      className="col-4"
                      key={`${input.type}-${input.name}-${idx}`}
                    >
                      {input.type === "dateTime" ? (
                        <div className="input-box">
                          <label>Date & Time</label>
                          <DatePicker
                            showTime
                            format="YYYY-MM-DD HH:mm:ss"
                            placeholder="Select Date & Time"
                            value={
                              input.value
                                ? dayjs(input.value, "YYYY-MM-DD HH:mm:ss")
                                : null
                            }
                            onChange={onChangeDateTime}
                            style={{ width: "100%" }}
                            disabled={submitStatus}
                          />
                          {errors.date_time_log && (
                            <p className="error-text">{errors.date_time_log}</p>
                          )}
                        </div>
                      ) : (
                        (() => {
                          const config = input.config;
                          const stateMap = {
                            runningHours: [running_Hour, set_Running_Hour],
                            totalRunningHours: [
                              total_Running_Hour,
                              set_Total_Running_Hour,
                            ],
                            feedPressure: [feed_Pr, set_Feed_Pr],
                            backPressure: [back_Pr, set_Back_Pr],
                            feedTemperature: [feed_Temp, set_Feed_Temp],
                            motorCurrent: [motor_Current, set_Motor_Current],
                            motorTemperature: [motor_Temp, set_Motor_Temp],
                            vibration: [vibration, set_Vibration],
                          };
                          const [, setValue] = stateMap[input.name] || [];
                          const unitStateMap = {
                            feedPressure: [
                              purifier_Feed_Pressure_Unit,
                              set_Purifier_Feed_Pressure_Unit,
                            ],
                            backPressure: [
                              purifier_Back_Pressure_Unit,
                              set_Purifier_Back_Pressure_Unit,
                            ],
                            feedTemperature: [
                              purifier_Feed_Temp_Unit,
                              set_Purifier_Feed_Temp_Unit,
                            ],
                            motorCurrent: [
                              purifier_Motor_Current_Unit,
                              set_Purifier_Motor_Current_Unit,
                            ],
                            motorTemperature: [
                              purifier_Motor_Temp_Unit,
                              set_Purifier_Motor_Temp_Unit,
                            ],
                            vibration: [vibration_Unit, set_Vibration_Unit],
                          };
                          const [, setUnit] = unitStateMap[input.name] || [];
                          const errorKey = `pr_${input.name.replace(
                            /([A-Z])/g,
                            (match) => `_${match.toLowerCase()}`
                          )}`;

                          return config.unitList && config.unitList.length ? (
                            <UnitWithInput
                              label={config.label}
                              value={input.value}
                              onChange={(e) => setValue(e.target.value)}
                              unit={input.unit}
                              onUnitChange={(e) => setUnit(e.target.value)}
                              disabled={submitStatus}
                              error={errors[errorKey]}
                              unitList={config.unitList}
                            />
                          ) : (
                            <div className="input-box">
                              <label>{config.label}</label>
                              <Input
                                disabled={submitStatus}
                                value={input.value}
                                placeholder={config.label}
                                onChange={(e) => setValue(e.target.value)}
                              />
                              {errors?.[errorKey] && (
                                <span style={{ color: "red" }}>
                                  {errors[errorKey]}
                                </span>
                              )}
                            </div>
                          );
                        })()
                      )}
                    </div>
                  ))}
                  {group.length < 3 &&
                    Array.from({ length: 3 - group.length }).map((_, idx) => (
                      <div
                        className="col-4"
                        key={`empty-combined-${i}-${idx}`}
                      ></div>
                    ))}
                </div>
              );
            }

            return rows;
          })()}

          {(() => {
            const rows = [];
            const otherParamsArray = Object.entries(otherParams || {});
            for (let i = 0; i < otherParamsArray.length; i += 3) {
              const group = otherParamsArray.slice(i, i + 3);
              rows.push(
                <div className="row" key={`other-row-${i}`}>
                  {group.map(([name, { value, unit }]) => (
                    <div className="col-4" key={name}>
                      <UnitWithInput
                        label={name}
                        value={value}
                        onChange={(e) =>
                          handleOtherParamChange(name, "value", e.target.value)
                        }
                        unit={unit}
                        onUnitChange={(e) =>
                          handleOtherParamChange(name, "unit", e.target.value)
                        }
                        disabled={submitStatus}
                        unitList={otherParameterUnits}
                      />
                    </div>
                  ))}
                  {group.length < 3 &&
                    Array.from({ length: 3 - group.length }).map((_, idx) => (
                      <div
                        className="col-4"
                        key={`empty-other-${i}-${idx}`}
                      ></div>
                    ))}
                </div>
              );
            }
            return rows;
          })()}
        </>
      )}
    </>
  );
}

export default AuxiliaryPurifier;
